import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';
import { ExternalSettings } from '../../services/external-settings/external-settings.interface';
import { ExternalSettingsService } from '../../services/external-settings/external-settings.service';
import { InternalSettings, PermissionList } from '../../services/internal-settings/internal-settings.interface';
import { InternalSettingsService, hasOnePermission } from '../../services/internal-settings/internal-settings.service';

@Component({
    selector: 'app-voice-command-header',
    templateUrl: './voice-command-header.component.html',
    styleUrls: ['./voice-command-header.component.less'],
    standalone: false
})
export class VoiceCommandHeaderComponent {

  destroy$: Subject<void> = new Subject();
  UIUtilityService: any = UIUtilityService;
  internalSettings!: InternalSettings;
  externalSettings!: ExternalSettings;
  hasPermission: boolean = false

  constructor(
    private router: Router,
    private srvIS: InternalSettingsService,
    private srvES: ExternalSettingsService
  ) {
    combineLatest([
      this.srvIS.getCurrentSettings(),
      this.srvES.externalSettings$,
    ]).pipe(takeUntil(this.destroy$))
      .subscribe(([internalSettings, externalSettings]) => {
        this.internalSettings = internalSettings;
        this.externalSettings = externalSettings;

        this.initialize();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  private initialize() {

    let isModuleEnabled = this.externalSettings.globalVariables.isModuleEnabledVoiceCommand;
    if (!isModuleEnabled) return;
    this.hasPermission = hasOnePermission([PermissionList.MOBILEARTH_ACCESS_VOICE_COMMAND], this.internalSettings.permissions!);
  }

  onButtonClick() {
    this.router.navigateByUrl("/voice-command");
  }

}
